module.exports = __webpack_public_path__ + "img/042-gravestone.954e8d44.png";